import { ITaskRunner, NeoModel } from '@singularsystems/neo-core';
import { AppService, Types } from '../../Services/AppService';
import ETInvestorVMBase from '../ETInvestorVMBase';
import InvestorTypeSectionConfig from '../../Models/Investors/InvestorTypeSectionConfig';
import { NotificationDuration } from '../../Models/Enums/NotificationDuration';

@NeoModel
export default class InvestorProfileVM extends ETInvestorVMBase {

    public sectionConfigs: InvestorTypeSectionConfig[] = [];

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private investorApiClient = AppService.get(Types.ApiClients.InvestorApiClient)) {

        super(taskRunner);
    }

    public async initialise() {
        const investorData = this.investorService.investorData!;

        await this.taskRunner.waitFor(
            Promise.all([
                investorData.getFicaStatusesAsync(),
                this.loadSectionConfigsAsync(this.taskRunner, investorData.investor?.investorTypeID ?? null)
            ])
        );
    }

    private async loadSectionConfigsAsync(taskRunner : ITaskRunner, investorTypeID : number | null) {

            if (!investorTypeID) {
            this.notifications.addDanger("Investor Type", "InvestorTypeID missing when loading section configs", NotificationDuration.Long);
            return;
        }

            const response = await taskRunner.waitFor(this.investorApiClient.getSectionConfigs(investorTypeID));
            this.sectionConfigs = response.data.map(config =>
                InvestorTypeSectionConfig.fromJSObject<InvestorTypeSectionConfig>(config)
            );
    }
}